import { I18nFormatter } from '../I18n/I18n';
import UserStore from '../../stores/UserStore';
import typeOf from '../../helpers/typeOf';
import store from '../../stores/redux';
import Helpers from './Helpers';
import {
    formatKeys
} from './config';


class Formatter extends Helpers {
    constructor() {
        super();
    }

    format(value = 0, keys, reportParams = {}) {
        const staticNames = UserStore.getTranslation().report;
        const params = this.getParams(keys);

        if (typeOf.isObject(keys) && keys.isTotals) {
            return staticNames.title.totalReport;
        }

        switch (params.format) {
            case formatKeys.number:
                value = this.number(value);
                break;
            case formatKeys.percent:
                value = this.percent(value);
                break;
            case formatKeys.currency:
                value = this.currency(value, reportParams.currency || store.getState().user?.publisher?.account?.balance?.currency, reportParams.isHtml);
                break;
            case formatKeys.date:
                value = this.date(value, params);
                break;
            case formatKeys.quarter:
                value = this.quarter(value);
                break;
            case formatKeys.boolean:
                value = this.boolean(value);
                break;
            case formatKeys.ids:
                value = this.ids(value, reportParams);
                break;
            case formatKeys.string:
                value = this.string(value);
                break;
            case formatKeys.array:
                value = this.array(value);
                break;
            default:
                value = !typeOf.isNumeric(value) && !value.length ? staticNames.undefined : value;
        }

        return value;
    }

    number(value) {
        return I18nFormatter.int(value);
    }

    percent(value) {
        return typeOf.isNumeric(value) ? I18nFormatter.percent(value) : value;
    }

    currency(value, currency, isHtml) {
        return typeOf.isNumeric(value) ? I18nFormatter.currency(value, currency, isHtml) : value;
    }

    date(value, params) {
        const type = params.dateType;
        const timeZone = store.getState().user.timezone;

        switch (type) {
            case 'dateTime':
                return I18nFormatter.dateTime(value, timeZone);
                break;
            case 'dateWeek':
                return I18nFormatter.dateWeek(value, timeZone);
                break;
            case 'dateMonth':
                return I18nFormatter.dateMonth(value, timeZone);
                break;
            case 'dateYear':
                return I18nFormatter.dateYear(value, timeZone);
                break;
            case 'dateWeekDay':
                return I18nFormatter.weekDay(value, timeZone);
                break;
            default:
                return I18nFormatter.date(value, timeZone);
        }
    }

    quarter(value) {
        let date = new Date(value);
        const year = date.getFullYear();
        const month = date.getMonth();
        let quarter = 1;

        if (month >= 4 && month < 6) {
            quarter = 2;
        }
        if (month >= 6 && month < 9) {
            quarter = 3;
        }
        if (month >= 9 && month < 12) {
            quarter = 4;
        }

        return `Q${quarter} ${year}`;
    }

    boolean(value) {
        if (typeOf.isNumeric(value)) {
            if (value) {
                value = `Yes (${value})`;
            } else {
                value = `No (${value})`;
            }
        }

        return value;
    }

    ids(id, reportParams) {
        const type = reportParams.group_by;
        let value = id;

        switch (type) {
            case 'Advertiser':
                value = _getTitle(id, 'advertiser', reportParams);
                break;
            case 'Period':
                value = _getTitle(id, 'period', reportParams);
                break;
            case 'Offer':
                value = _getTitle(id, 'offers', reportParams);
                break;
            case 'Goal':
                value = _getTitle(id, 'goals', reportParams);
                break;
            case 'Link':
                value = _getTitle(id, 'links', reportParams);
                break;
            case 'Country':
                value = _getTitle(id, 'regions', reportParams);
                break;
        }

        return value;
    }

    string(value) {
        return value;
    }

    array(value) {
        return typeOf.isArray(value) ? value.join(', ') : '';
    }
}

const _getTitle = (id, dataType, reportParams) => {
    const data = store.getState()[dataType].list;
    const staticNames = UserStore.getTranslation().report;
    let title = `(${id}) ${staticNames.undefined}`;

    if (data.length && !reportParams.isChange) {
        let item = data.find((item) => +item.id === +id);

        if (item) {
            title = item && (`(${id}) ${item.title}`) || title;
        }
    } else {
        title = id;
    }

    return title;
};

export default Formatter;
